import { render, staticRenderFns } from "./FddIcon.vue?vue&type=template&id=4b0e685c&"
import script from "./FddIcon.vue?vue&type=script&lang=js&"
export * from "./FddIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports